/*
  Truffe & Poil : barre d'ajout au panier collante (mobile).
  - Visible uniquement quand le bouton principal n'est pas à l'écran.
  - Le clic déclenche le bouton principal (même formulaire, mêmes contrôles).
  - Recopie l'état du bouton principal (rupture, indisponible), le prix, la variante et sa photo.
*/
if (!customElements.get('tp-sticky-atc')) {
  customElements.define(
    'tp-sticky-atc',
    class TpStickyAtc extends HTMLElement {
      connectedCallback() {
        // Pas de barre collante dans la fenêtre « ajout rapide » (copie de la fiche produit)
        if (this.closest('quick-add-modal')) return;
        this.sectionId = this.dataset.sectionId;
        this.stickyButton = this.querySelector('[data-tp-sticky-button]');
        this.mainButton = document.getElementById(`ProductSubmitButton-${this.sectionId}`);
        if (!this.mainButton || !this.stickyButton) return;

        this.mobileQuery = window.matchMedia('(max-width: 749px)');
        this.mainVisible = true;

        this.stickyButton.addEventListener('click', () => this.mainButton.click());

        this.visibilityObserver = new IntersectionObserver(([entry]) => {
          this.mainVisible = entry.isIntersecting;
          this.toggle();
        });
        this.buttonObserver = new MutationObserver(() => this.syncButton());
        this.watch(this.mainButton);
        this.mobileQuery.addEventListener('change', () => this.toggle());

        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
            if (event.data.sectionId !== this.sectionId) return;
            this.syncFromMain(event.data.variant, event.data.html);
          });
        }
      }

      disconnectedCallback() {
        this.visibilityObserver?.disconnect();
        this.buttonObserver?.disconnect();
        this.unsubscribe?.();
      }

      watch(button) {
        this.visibilityObserver.disconnect();
        this.buttonObserver.disconnect();
        this.mainButton = button;
        this.visibilityObserver.observe(button);
        this.buttonObserver.observe(button, {
          attributes: true,
          attributeFilter: ['disabled'],
          childList: true,
          characterData: true,
          subtree: true,
        });
      }

      toggle() {
        const show = this.mobileQuery.matches && !this.mainVisible;
        this.classList.toggle('is-visible', show);
        this.setAttribute('aria-hidden', String(!show));
        this.toggleAttribute('inert', !show);
        document.body.classList.toggle('tp-has-sticky-atc', show);
      }

      syncButton() {
        const label = this.querySelector('[data-tp-sticky-label]');
        const mainLabel = this.mainButton.querySelector('span');
        if (label && mainLabel) label.textContent = mainLabel.textContent.trim();
        this.stickyButton.disabled = this.mainButton.hasAttribute('disabled');
      }

      syncFromMain(variant, html) {
        // Si Dawn a remplacé le bouton principal, on surveille le nouveau
        const mainButton = document.getElementById(`ProductSubmitButton-${this.sectionId}`);
        if (mainButton && mainButton !== this.mainButton) this.watch(mainButton);
        this.syncButton();

        const priceWrapper = document.getElementById(`price-${this.sectionId}`);
        const priceSource =
          priceWrapper?.querySelector('.price--on-sale .price-item--sale') ||
          priceWrapper?.querySelector('.price__regular .price-item--regular');
        const price = this.querySelector('[data-tp-sticky-price]');
        if (price && priceSource) price.textContent = priceSource.textContent.trim();

        const variantLabel = this.querySelector('[data-tp-sticky-variant]');
        if (variantLabel && variant) variantLabel.textContent = variant.title;

        // La section re-rendue par Dawn contient déjà la vignette de la nouvelle variante
        const media = this.querySelector('[data-tp-sticky-media]');
        const sourceMedia = html?.querySelector(
          `tp-sticky-atc[data-section-id="${this.sectionId}"] [data-tp-sticky-media]`
        );
        if (media && sourceMedia && media.innerHTML !== sourceMedia.innerHTML) {
          media.innerHTML = sourceMedia.innerHTML;
        }
      }
    }
  );
}
